import React from 'react'
import { Grid } from '@mui/material'
import Fail2banStatChart from './Fail2banStatChart'
import Fail2banDetailChart from './Fail2banDetailChart'

const Fail2banCard = () => (
    <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
            <Fail2banStatChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
            <Fail2banDetailChart />
        </Grid>
    </Grid>
)

export default Fail2banCard
